import { render, staticRenderFns } from "./MyHistorialTable.vue?vue&type=template&id=f789553c"
import script from "./MyHistorialTable.vue?vue&type=script&lang=js"
export * from "./MyHistorialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports